import { setGlobalProblemHandler } from './globalHandler';
import { useState } from "react";
import { ProblemDetails } from "./ProblemDetails";
import { ProblemDetailsContext } from "./context";

export const ProblemDetailsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [problem, setProblem] = useState<ProblemDetails | null>(null);

  setGlobalProblemHandler(setProblem);

  return (
    <ProblemDetailsContext.Provider value={{ problem, setProblem }}>
      {children}
    </ProblemDetailsContext.Provider>
  );
};
